'use client';

import { ComponentProps } from 'react';
import { drawerStyles } from './Drawer.styles';
import { DrawerProps } from './Drawer.types';
import { Drawer as DrawerPrimitive } from 'vaul';
import { useBreakpoint } from '@onbeam/utils';
import { token } from '@onbeam/business-styled-system/tokens';
import { CloseIcon } from '@onbeam/icons/business';
import { cx } from '@onbeam/business-styled-system/css';
import { customScrollbar } from '@onbeam/business-styled-system/recipes';

const classes = drawerStyles();

export const Drawer = ({
  direction: directionProp,
  trigger,
  title,
  hideTitle,
  description,
  hideDescription,
  children,
  ...props
}: DrawerProps) => {
  const isMobile = useBreakpoint({ max: token('breakpoints.md') });

  const direction: ComponentProps<typeof DrawerPrimitive.Root>['direction'] =
    directionProp ?? (isMobile ? 'bottom' : 'right');

  return (
    <DrawerPrimitive.Root direction={direction} {...props}>
      {trigger && (
        <DrawerPrimitive.Trigger asChild>{trigger}</DrawerPrimitive.Trigger>
      )}
      <DrawerPrimitive.Portal>
        <DrawerPrimitive.Overlay
          className={classes.overlay}
          style={{ backdropFilter: 'blur(4px)' }}
        />
        <DrawerPrimitive.Content
          className={cx('drawerContent', customScrollbar(), classes.root)}
        >
          {['left', 'right'].includes(direction) && (
            // TODO: Replace with Button icon variant/size when it exists
            <DrawerPrimitive.Close className={classes.close}>
              <CloseIcon height={16} width={16} />
            </DrawerPrimitive.Close>
          )}
          <div className={classes.content}>
            {direction === 'bottom' && (
              <div className={classes.thumb} aria-hidden />
            )}
            {title && (
              <DrawerPrimitive.Title
                data-hidden={hideTitle}
                className={classes.title}
              >
                {title}
              </DrawerPrimitive.Title>
            )}
            {description && (
              <DrawerPrimitive.Description
                data-hidden={hideDescription}
                className={classes.description}
              >
                {description}
              </DrawerPrimitive.Description>
            )}
            {children}
          </div>
        </DrawerPrimitive.Content>
      </DrawerPrimitive.Portal>
    </DrawerPrimitive.Root>
  );
};

export const DrawerClose = DrawerPrimitive.Close;
